import styled, { css } from 'styled-components'
import CardContainer, { ControlButton } from 'live/components/ui/CardContainer'
import LiveCardContainer from 'live/components/ui/CardContainer'
import theme from 'live/services/theme'

export const DashboardsContainer = styled(LiveCardContainer)`
    width: 100%;
    padding: unset;
    position: unset;

    header {
        z-index: 3;
        height: 54px;
        display: flex;
        padding: 18px;
        align-items: center;
        box-shadow: 0px 3px 4px -3px rgba(54, 65, 89, 0.2);
        > div {
            font-size: 16px !important;
        }
        user-select: none;
    }
    div.LinkedDashboards__EmptyStateContainer-ayo76r-4 {
        z-index: 9;
    }
`

export const StyledCardContainer = styled(CardContainer)<{ fullscreen: boolean }>`
    /* position relative and the z-index on the header is important to keep the export dropdown above the header */
    position: relative;
    padding: 0;
    /* z-index: 0; */
    ${props =>
        props.fullscreen &&
        css`
            position: fixed;
            top: 55px;
            left: 8px;
            background-color: #fff;
            height: calc(100% - 90px);
            width: calc(100% - 20px);
            overflow: auto;
            z-index: 200;
            transform: translate(100% - 90px, 100% - 40px);
        `}
    header {
        /* position relative and the z-index on the header is important to keep the export dropdown above the header */
        z-index: 3;
        padding: 18px;
        height: 54px;
        > div {
            font-size: 16px !important;
        }
        user-select: none;
    }
    ${ControlButton} {
        span {
            margin-right: 4px;
        }
    }
`
